export const IDLE_TIMEOUT_MINUTES = 30;
export const MAX_UPLOAD_MB = 10;
export const BYTES_PER_MB = 1024 * 1024;
export const QUERY_STALE_TIME_MS = 60 * 1000;
